module.exports = "/_next/static/images/bee603b1c0f66dae00f01edbf8739edd-cuenta.svg.webp";